import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';

class InfoArrFunc {
  static get_info_arr_by_filter(inData: any) {
    let opt_obj = {
      info_arr: [],
      list_opt: {
        s_addon_todo_start_date: "",
        s_addon_todo_s_state: "",//complete,ing,not_complete
        s_addon_todo_s_todo_sort: "",//study,homework
      },
      base_date_str: "",
      pre_date_str: "",
      is_only_now_desk: false,
      ...inData
    };
    let info_arr = opt_obj["info_arr"];
    let base_date_str = opt_obj["base_date_str"];
    let pre_date_str = opt_obj["pre_date_str"];

    let new_info_arr = [];
    let info_arr_len = info_arr.length;
    for (let i = 0; i < info_arr_len; i++) {
      let info = info_arr[i];
      let td_sort_data_json = TodoInfoArrFunc.get_td_sot_data_arr({
        info: info,
        base_date_str: base_date_str,
        pre_date_str: pre_date_str,
      });
      info.td_sort_data_json = td_sort_data_json;

      let is_add_info = true;
      if (opt_obj["list_opt"]["s_addon_todo_s_state"] != "") {
        is_add_info = false;
        let todo_percent = info.td_sort_data_json["study"]["percent"];
        let todo_count = info.td_sort_data_json["study"]["count"];
        if (opt_obj["list_opt"]["s_addon_todo_s_todo_sort"] == "homework") {
          todo_percent = info.td_sort_data_json["pre_homework"]["percent"];
          todo_count = info.td_sort_data_json["pre_homework"]["count"];
        }
        if (opt_obj["list_opt"]["s_addon_todo_s_state"] == "complete") {
          if (todo_percent >= 100) {
            is_add_info = true;
          }
        } else if (opt_obj["list_opt"]["s_addon_todo_s_state"] == "ing") {
          if (todo_percent > 0 && todo_percent < 100) {
            is_add_info = true;
          }
        } else {
          if (todo_percent >= 0 && todo_percent < 100 && todo_count > 0) {
            is_add_info = true;
          }
        }
      }
      if (opt_obj["is_only_now_desk"]) {
        let now_desku_arr: any = [];
        //현재 데스크 사용중인 학생만
        if (info.desk_use_arr && info.desk_use_arr.length > 0) {
          now_desku_arr = DeskUseDataFunc.get_now_desku_arr({
            now_ymdhis: base_date_str+" "+DateFunc.get_date_format(new Date(),"h:i:s"),
            desku_arr: info.desk_use_arr,
          });
        }
        info.now_desku_arr = now_desku_arr;
        if(now_desku_arr==0){
          is_add_info = false;
        }
      }

      if (is_add_info) {
        new_info_arr.push(info);
      }
    }
    info_arr = new_info_arr;

    return info_arr;
  };
}
export default InfoArrFunc;